import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ReportsRequestPage.SectionReportName', {
    label: 'Report name',
    placeholder: 'Enter report name...',
});
